import React, { useEffect, useState, CSSProperties } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/Computation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labg from "./images/iconsb/labb.png"
import labService from './labService';
import HashLoader from "react-spinners/HashLoader";



const Computation = ({ isCollapsed, toggleSidebar }) => {
  const navigate = useNavigate();
  const { pk } = useParams(); // Get the `pk` from the URL parameters
  const [redirectUrl, setRedirectUrl] = useState(null);

  const goToLab = () => {
    navigate('/laboratory');
  };

  useEffect(() => {
    const checkComputationStatus = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const token = user.access;
        const response = await labService.checkComputationStatus(pk, token);
        if (response.data.redirect_url) {
          // If computation is done, redirect to result page
          navigate(response.data.redirect_url);
        }
      } catch (error) {
        console.error("Error fetching computation status:", error);
      }
    };

    // Poll every 10 seconds
    const intervalId = setInterval(checkComputationStatus, 10000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [pk, navigate]);


  return (
    <div className='lab-container'>
      <Navbar />
      <div className='lab-side-content'>
        <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <div className='new-pred-container'>
          <div className='np-tabs'>
            <div className='x'>
              <button onClick={goToLab} className='x-but'>
                <FontAwesomeIcon className='icon-x' icon={faX} />
              </button>
            </div>
            <div className='np-steps dr-tab-1'>
              <p className='p-step'>STEP 1</p>
              <p className='mar-btm-few'>Select endpoints</p>
            </div>
            <div className='np-steps dr-tab-2'>
              <p className='p-step'>STEP 2</p>
              <p className='mar-btm-few'>Define Nanoform</p>
            </div>
            <div className='np-steps dr-tab-3'>
              <p className='p-step'>STEP 3</p>
              <p className='mar-btm-few'>Summary</p>
            </div>
            <div className='np-steps dr-tab-4'>
              <p className='p-step'>STEP 4</p>
              <p className='mar-btm-few'>Results</p>
            </div>
          </div>
          <div className='np-content'>
            <div className='loading-comp' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <HashLoader
                className='loader'
                size={80}
                color='#1B4480'
              />
              <div className='load-div' style={{ marginTop: '20px', textAlign: 'center' }}>
                <p className='comp-run'>Computation running...</p>
                <p className='you-can-go'>You can go to the</p>
                <button onClick={goToLab} className='lab-load'>
                  <img className="lab-load-icon" src={labg} alt="laboratory" />
                  Laboratory
                </button>
                <p>and wait for the results.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Computation;
